'use client';

import { useFormState } from 'react-dom';
import { sendResetPasswordEmail } from '../actions/send-reset-password-email.action';
import { TextInput } from '@prickle/next-ui';
import { ErrorMessage } from '@tuning-bytes/users/ui';
import { ResetPasswordButton } from './reset-password-button.component';
import { useTranslations } from 'next-intl';

export const ResetPasswordForm = () => {
  const [errorMessage, dispatch] = useFormState(
    sendResetPasswordEmail,
    undefined,
  );
  const t = useTranslations('ResetPasswordPage.form');

  return (
    <form action={dispatch} className="space-y-4">
      <div className="space-y-2">
        <TextInput
          name="email"
          placeholder="example@acme.com"
          bordered
          label={{
            text: t('email'),
            position: 'top',
            required: true,
          }}
        />
      </div>

      <ResetPasswordButton />
      <ErrorMessage errorMessage={errorMessage} />
    </form>
  );
};
